var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileImageUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2065_67823",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 69
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.9995,
    cy: 34.855,
    r: 34.1333,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2065_67823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.135 1C16.2782 1 1 16.2782 1 35.135C1 53.9918 16.2782 69.27 35.135 69.27C53.9918 69.27 69.27 53.9918 69.27 35.135C69.27 16.2782 53.9918 1 35.135 1ZM35.135 14.2135C41.8244 14.2135 47.2474 19.6366 47.2474 26.326C47.2474 33.0153 41.8244 38.4384 35.135 38.4384C28.4456 38.4384 23.0226 33.0153 23.0226 26.326C23.0226 19.6366 28.4456 14.2135 35.135 14.2135ZM35.135 61.5621C27.0555 61.5621 19.8155 57.9008 14.9706 52.175C17.5582 47.3025 22.6234 43.944 28.5282 43.944C28.8586 43.944 29.1889 43.9991 29.5055 44.0954C31.2948 44.6735 33.1667 45.0452 35.135 45.0452C37.1033 45.0452 38.9889 44.6735 40.7645 44.0954C41.0811 43.9991 41.4114 43.944 41.7418 43.944C47.6466 43.944 52.7118 47.3025 55.2994 52.175C50.4545 57.9008 43.2145 61.5621 35.135 61.5621Z",
    fill: "#E5E8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2857 26.9286H28.6326L28.7541 26.6037L29.4129 24.8414C29.4129 24.8413 29.413 24.8412 29.413 24.8412C29.7148 24.0352 30.4868 23.5 31.35 23.5H38.0732C38.9365 23.5 39.7086 24.0353 40.0103 24.8414L40.0107 24.8424L40.675 26.6049L40.797 26.9286H41.1429H45.8571C47.0006 26.9286 47.9286 27.8565 47.9286 29V44.4286C47.9286 45.5721 47.0006 46.5 45.8571 46.5H23.5714C22.4279 46.5 21.5 45.5721 21.5 44.4286V29C21.5 27.8565 22.4279 26.9286 23.5714 26.9286H28.2857ZM41.6429 36.7143C41.6429 32.8917 38.5369 29.7857 34.7143 29.7857C30.8917 29.7857 27.7857 32.8917 27.7857 36.7143C27.7857 40.5369 30.8917 43.6429 34.7143 43.6429C38.5369 43.6429 41.6429 40.5369 41.6429 36.7143ZM38.9286 36.7143C38.9286 39.0364 37.0364 40.9286 34.7143 40.9286C32.3922 40.9286 30.5 39.0364 30.5 36.7143C30.5 34.3922 32.3922 32.5 34.7143 32.5C37.0364 32.5 38.9286 34.3922 38.9286 36.7143Z",
    fill: "#FAFAFA",
    stroke: "#2C2C2C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImageUpload);
export default __webpack_public_path__ + "static/media/ProfileImageUpload.55348fca316a08b1de4ba8084d654391.svg";
export { ForwardRef as ReactComponent };